import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

declare var $: any;

@Component({
  standalone: false,
  selector: 'app-subadmin-mgt',
  templateUrl: './subadmin-mgt.component.html',
  styleUrls: ['./subadmin-mgt.component.css']
})
export class SubadminMgtComponent implements OnInit {

  searchForm: FormGroup | any;
  subAdminList: any = [];
  userId: any;
  currentPage: any = 1;
  itemPerPage: any = 10;
  total: any;
  subadminStatus: any;
  maxDate: Date | any;

  constructor(private mainService: MainService, private router: Router) { }

  ngOnInit() {
    this.searchForm = new FormGroup({
      'search': new FormControl(''),
      'disease': new FormControl(''),
      'status': new FormControl(''),
      'fromDate': new FormControl(''),
      'toDate': new FormControl('')
    });
    // this.minDate = new Date(currentYear - 20, 0, 1);
    const currentYear = new Date()
    this.maxDate = new Date(currentYear);
    this.mainService.BlockFuture();
    this.getSubAdminList();
  }

  pagination(page: any) {
    this.currentPage = page;
    this.getSubAdminList();

  }

  Reset() {
    this.searchForm.reset();
    this.getSubAdminList();
  }
  deleteUserModal(id: any) {
    this.userId = id
    $('#deleteUser').modal('show')
  }

  // delete subadmin Api integration 
  deleteSubadminApi() {
    const data = {
      "userId": this.userId,
      "status": "DELETE"
    }
    this.mainService.showSpinner();
    this.mainService.postApi(ApiUrls.actionPerform, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        $('#deleteUser').modal('hide')
        this.mainService.successToast(res.responseMessage)
        this.mainService.hideSpinner();
        this.getSubAdminList();
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

  openActiveBlock(status: any, id: any) {
    this.subadminStatus = status;
    this.userId = id;
    $('#actBlockStatus').modal('show')
  }

  updateActiveBlock() {
    this.subadminStatus == 'ACTIVE' ? this.subadminStatus = 'BLOCK' : this.subadminStatus = 'ACTIVE';
    const data = {
      userId: this.userId,
      status: this.subadminStatus
    }
    this.mainService.postApi(ApiUrls.actionPerform, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        $('#actBlockStatus').modal('hide')
        this.mainService.successToast(res.responseMessage)
        this.getSubAdminList();
      }
      else {
        this.mainService.errorToast(res.responseMessage)
      }
    })

  }

  // getSubAdminList api integration 
  getSubAdminList() {
    if (this.searchForm.value.fromDate && this.searchForm.value.toDate) {
      if (this.searchForm.value.fromDate > this.searchForm.value.toDate) {
        this.mainService.errorToast('Start time should be less than end time');
        return

      }
    }

    let date = new Date(this.searchForm.value.fromDate);
    let year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let dt: any = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let date1 = new Date(this.searchForm.value.toDate);
    let year1 = date1.getFullYear();
    let month1: any = date1.getMonth() + 1;
    let dt1: any = date1.getDate();

    if (dt1 < 10) {
      dt1 = '0' + dt1;
    }
    if (month1 < 10) {
      month1 = '0' + month1;
    }


    let data = {
      "search": this.searchForm.value.search,
      "pageNumber": this.currentPage,
      "fromDate": this.searchForm.value.fromDate,
      "toDate": this.searchForm.value.toDate,
    }
    if (this.searchForm.value.fromDate) {
      data['fromDate'] = year + '-' + month + '-' + dt
    }
    if (this.searchForm.value.toDate) {
      data['toDate'] = year1 + '-' + month1 + '-' + dt1
    }

    this.mainService.showSpinner();
    this.mainService.postApi(ApiUrls.subadminList + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.subAdminList = res.result ? res.result : '';
        this.total = res.paginationData.total
        this.mainService.hideSpinner();
      } else {
        this.subAdminList = res.result ? res.result : '';
        this.mainService.hideSpinner();
      }
    })
  }

  viewSubadmin(id: any) {
    this.router.navigate(['view-subadmin/' + id])
  }

  editSubadmin(id: any) {
    this.router.navigate(['edit-subadmin/' + id])

  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
